/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EColorSkin } from "../types/EColorSkin.ts";

/**
 * @description 1 = White | 2 = Black | 3 = BrownMixed | 4 = Yellow | 5 = Indigenous | 6 = NoInformationAvailable | 7 = NoDeclare |
 */
export const eColorSkinSchema = z
  .union([
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5),
    z.literal(6),
    z.literal(7),
  ])
  .describe(
    "1 = White | 2 = Black | 3 = BrownMixed | 4 = Yellow | 5 = Indigenous | 6 = NoInformationAvailable | 7 = NoDeclare | ",
  ) as unknown as ToZod<EColorSkin>;
